
import { toast } from 'sonner';

/**
 * Saves data to sessionStorage with error handling
 */
export const saveToSessionStorage = <T>(key: string, data: T): boolean => {
  try {
    sessionStorage.setItem(key, JSON.stringify(data));
    return true;
  } catch (error) {
    console.error('Error saving to sessionStorage:', error);
    if (error instanceof DOMException && (
      // everything except Firefox
      error.name === 'QuotaExceededError' ||
      // Firefox
      error.name === 'NS_ERROR_DOM_QUOTA_REACHED'
    )) {
      toast.error('Storage limit reached', {
        description: 'Please clear your browser cache and try again'
      });
    } else {
      toast.error('Failed to save session data');
    }
    return false;
  }
};

/**
 * Gets data from sessionStorage with error handling
 */
export const getFromSessionStorage = <T>(key: string): T | null => {
  try {
    const stored = sessionStorage.getItem(key);
    if (!stored) return null;
    return JSON.parse(stored) as T;
  } catch (error) {
    console.error('Error retrieving from sessionStorage:', error);
    return null;
  }
};

/**
 * Removes data from sessionStorage with error handling
 */
export const removeFromSessionStorage = (key: string): boolean => {
  try {
    sessionStorage.removeItem(key);
    return true;
  } catch (error) {
    console.error('Error removing from sessionStorage:', error);
    return false;
  }
};

/**
 * Clears all sessionStorage with error handling
 */
export const clearSessionStorage = (): boolean => {
  try {
    sessionStorage.clear();
    return true;
  } catch (error) {
    console.error('Error clearing sessionStorage:', error);
    return false;
  }
};
